import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import UserActivity from "./userActivity";
import AppShell from "./components/layout/AppShell";

const ProtectedRoute = ({ children, isAdminRoute }) => {
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  const isAdminStorage = sessionStorage.getItem("isAdmin") === "true";
  const navigate = useNavigate();

  useEffect(() => {
    const authenticatedCookie = Cookies.get("authenticated");
    const onSessionCookie = Cookies.get("onSession");
    const authenticatedStorage = sessionStorage.getItem("authenticated");
    const onSessionStorage = sessionStorage.getItem("onSession");

    const isAuthenticated = authenticatedCookie || authenticatedStorage;
    const isOnSession = onSessionCookie || onSessionStorage;

    if (!isAuthenticated || !isOnSession) {
      navigate("/login");
    } else if (isAdminRoute && !isAdmin && !isAdminStorage) {
      navigate(-1);
    }
  }, [isAdmin, isAdminRoute, isAdminStorage, navigate]);

  return (
    <AppShell isAdmin={isAdmin || isAdminStorage}>
      <UserActivity />
      <div className="page-container">{children}</div>
    </AppShell>
  );
};

export default ProtectedRoute;
